import { createContext } from 'react';
import { PublicApiSettings } from '../../../../Gql/config';

export interface SettingsContextProps {
  googleMapsApiKey?: string;
  googleMapsMarker?: string;
  apiUrl?: string;
  publicApi?: PublicApiSettings;
  ecomSettings?: {
    url: string;
    useBankId?: boolean;
    displayBankIdAlert?: boolean;
    serviceLogotypeUrl?: string;
    serviceLogotypeUrlX2?: string;
    bankIdThumbprint?: string;
  };
}

export const SettingsContext = createContext<SettingsContextProps>({});
